import React from 'react';
import { Link as LinkRouter, LinkProps } from 'react-router-dom';

interface LinkP extends LinkProps {
  active: true | false,
}

function Link({
  children, to, active,
}: LinkP) {
  return (
    <LinkRouter to={to} className={`component-link ${active ? 'component-link-active' : ''}`}>
      <div>
        { children }
      </div>
    </LinkRouter>
  );
}

export default Link;

Link.defaultProps = {
  active: false,
}
